module.exports = __webpack_public_path__ + "img/wetNwild2.9cb24803.jpg";